// Pure selection logic used by FormContainerWithList after a record list
// changes (most commonly: right after a delete). Extracted so the actual
// decision rule -- which used to inline a `findIndex` + `list[index]` lookup
// that produced `list[-1]` (undefined) whenever the previously-selected
// record was no longer in the list -- can be unit tested without mounting
// the rest of that component.
export type NextSelection =
  | { type: "empty" }
  | { type: "select"; index: number };

export function resolveNextSelection(
  list: any[] | undefined,
  idKey: string,
  currentSelectionId: any,
  hasSelection: boolean,
  fallbackId?: any,
): NextSelection {
  // Some callers (e.g. AddressBookForm/ContactForm's getDataList) store
  // whatever the list endpoint returned without checking it's actually an
  // array -- a misshapen response (or, as in a couple of tests, a mocked one)
  // can leave this as a plain object. `{}.length` is undefined, not 0, so a
  // bare `list.length === 0` check lets it through; `list[0]` on a non-array
  // is then undefined, crashing handleRowAction's `row[sectionIdKey]` access.
  if (!Array.isArray(list) || list.length === 0) {
    return { type: "empty" };
  }
  let index = -1;
  if (hasSelection) {
    index = list.findIndex((item) => item[idKey] === currentSelectionId);
  } else if (fallbackId != null) {
    index = list.findIndex((item) => item[idKey] === fallbackId);
  }
  if (index === -1) index = 0;
  return { type: "select", index };
}
